<template>
  <div id="examples" :style="{ minHeight: this.$store.getters.fullWindowHeightMinusFooter }">
    <div class="wrapper py-6">

      <Gallery>
        <GitemExamples
          v-for="(example, index) in allExamples"
          :key="index"
          :data="example"
        ></GitemExamples>
      </Gallery>

    </div>
  </div>
</template>

<script>
// import db from '@/firebase/init'
// import { mapState } from 'vuex'
import Gallery from '../components/Gallery.vue'
import GitemExamples from '../components/GitemExamples.vue'

export default {
  name: 'examples',

  components: {
    Gallery,
    GitemExamples
  },

  data () {
    return {
      // examples: [],
      means: []
    }
  },

  created () {
    this.$store.dispatch('storeExamples')
  },

  computed: {
    allExamples () {
      return this.$store.state.examples
    }
    // ...mapState(['vuexExamples'])
  }

  /* created () {
    // - get examples data from firestore
    db.collection('kohteet').get().then(snapshot => {
    // - snapshot refers to aforementioned collection at that current point in time
      snapshot.docs.forEach(doc => {
      // - .docs muuttaa snapshotin array-muotoon
        let example = doc.data()
        // example.id = doc.id
        this.examples.push(example)
      })
    })
  } */
}
</script>

<style lang="scss">
</style>
